
import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Skeleton } from "@/components/ui/skeleton";

export const LoadingTabs = () => {
  return (
    <Tabs value="biography" className="space-y-8">
      <TabsList className="w-full justify-center border-b bg-transparent p-0 space-x-2 md:space-x-4">
        <TabsTrigger 
          value="biography" 
          className="text-sm md:text-base data-[state=active]:border-b-2 data-[state=active]:border-brand-primary px-2 md:px-4 py-2 transition-all duration-300"
        >
          Biography
        </TabsTrigger>
        <TabsTrigger 
          value="gallery" 
          className="text-sm md:text-base px-2 md:px-4 py-2 transition-all duration-300"
        >
          Gallery
        </TabsTrigger>
        <TabsTrigger 
          value="community" 
          className="text-sm md:text-base px-2 md:px-4 py-2 transition-all duration-300"
        >
          Community
        </TabsTrigger>
      </TabsList>

      <TabsContent value="biography" className="animate-fade-in">
        <div className="space-y-8 md:space-y-12">
          {/* Biography timeline skeleton */}
          <div className="max-w-2xl mx-auto">
            <Skeleton className="h-8 w-72 mx-auto mb-6" />
            <div className="space-y-4">
              {[1, 2, 3, 4].map((i) => (
                <Skeleton key={i} className="h-24 w-full rounded-lg" />
              ))}
            </div>
          </div>
          
          {/* About section skeleton */}
          <div className="max-w-2xl mx-auto mb-12">
            <Skeleton className="h-8 w-56 mx-auto mb-6" />
            <div className="space-y-6">
              {[1, 2, 3].map((i) => (
                <Skeleton key={i} className="h-32 w-full rounded-lg" />
              ))}
            </div>
          </div>
          
          {/* Info cards skeleton */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[1, 2, 3, 4].map((i) => (
              <Skeleton key={i} className="h-48 w-full rounded-xl" />
            ))}
          </div>
        </div>
      </TabsContent>
    </Tabs>
  );
};
